import {
  ISoccerMatchCardEvent,
  ISoccerMatchEvent,
  ISoccerMatchGoalEvent,
  ISoccerMatchMissedPenaltyEvent,
  ISoccerMatchPenaltyShotEvent,
  SoccerMatchEventType,
} from "../../../../../types";
import {
  GlobalCardEvent,
  GlobalGoalEvent,
  GlobalMissedPenaltyEvent,
  GlobalPenaltyShot,
} from "../../GlobalMatchEvents";

export default function LineupMatchEvents({
  event,
}: {
  event: ISoccerMatchEvent;
}) {
  switch (event.eventType) {
    case SoccerMatchEventType.CARD: {
      return (
        <GlobalCardEvent
          event={event as ISoccerMatchCardEvent}
          iconSize={16}
          showTime={true}
          wrapperClassName="match-event"
          timeClassName="time-match-key-event"
        />
      );
    }
    case SoccerMatchEventType.GOAL: {
      return (
        <GlobalGoalEvent
          event={event as ISoccerMatchGoalEvent}
          iconSize={16}
          showTime={true}
          wrapperClassName="match-event"
          timeClassName="time-match-key-event"
        />
      );
    }
    case SoccerMatchEventType.MISSED_PENALTY: {
      return (
        <GlobalMissedPenaltyEvent
          event={event as ISoccerMatchMissedPenaltyEvent}
          iconSize={16}
          showTime={true}
          wrapperClassName="match-event"
          timeClassName="time-match-key-event"
        />
      );
    }
    case SoccerMatchEventType.PENALTY_SHOT: {
      return (
        <GlobalPenaltyShot
          event={event as ISoccerMatchPenaltyShotEvent}
          iconSize={16}
          showTime={true}
          wrapperClassName="match-event"
          timeClassName="time-match-key-event"
        />
      );
    }
    default:
      return null;
  }
}
